import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		testStore:"wwwww"
	},
	getters: {},
	mutations: {
		changeOpenId(state, str) {
			state.openId = str;
		}
	},
	actions: {
		setOpenId(context, str) {//设置openid
			context.commit('changeOpenId', str);
		}
	}
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js